<button type="button" class="info-hint"
	[ngbPopover]="text"
	[popoverTitle]="title"
	triggers="click"
	placement="auto"
	container="body"
	autoClose="outside"
	popoverClass="info-hint-popover"
	[attr.aria-label]="ariaLabel">
	<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24"
		fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
		<circle cx="12" cy="12" r="10"></circle>
		<line x1="12" y1="16" x2="12" y2="12"></line>
		<line x1="12" y1="8" x2="12.01" y2="8"></line>
	</svg>
</button>
